import { r as isArray, i as isUndefined } from './vidstack-DoOmgEfT.js';

class TimeRange {
  get length() {
    return this.$.length;
  }
  constructor(start, end) {
    if (isArray(start)) {
      this.$ = start;
    } else if (!isUndefined(start) && !isUndefined(end)) {
      this.$ = [[start, end]];
    } else {
      this.$ = [];
    }
  }
  start(index) {
    return this.$[index][0] ?? Infinity;
  }
  end(index) {
    return this.$[index][1] ?? Infinity;
  }
}
function getTimeRangesStart(range) {
  if (!range.length)
    return null;
  let min = range.start(0);
  for (let i = 1; i < range.length; i++) {
    const value = range.start(i);
    if (value < min)
      min = value;
  }
  return min;
}
function getTimeRangesEnd(range) {
  if (!range.length)
    return null;
  let max = range.end(0);
  for (let i = 1; i < range.length; i++) {
    const value = range.end(i);
    if (value > max)
      max = value;
  }
  return max;
}

export { TimeRange as T, getTimeRangesEnd as a, getTimeRangesStart as g };
